<template>
    <div>
        <div class="kit__utils__heading">
          <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="row justify-content-between">
            <div class="col-6 col-lg-4 col-md-4 col-sm-3" v-for="item in getBankSum" :key="item.bankServiceId">
              <div class="row justify-content-between" style="border:1px solid ;border-radius: 5px;">
                <div class="col-12 col-lg-4 col-sm-12 p-4">
                  <a-card hoverable style="width: 100%;">
                    <img slot="cover" alt="example" :src="PreviewImg(item.icon)" />
                  </a-card>
                </div>
                <div class="col-12 col-lg-8 col-sm-12 p-2 mt-1">
                  <label>{{(item.longName !== '')?item.longName:'ไม่พบข้อมูล'}}({{(item.short !== '')?item.short:'ไม่พบข้อมูล'}})</label><br>
                  <label>ชื่อบัญชี : {{(item.accountName !== '')?item.accountName:'ไม่พบข้อมูล'}}</label><br>
                  <label>เลขที่บัญชี : {{(item.accountNumber !== '')?item.accountNumber:'ไม่พบข้อมูล'}}</label><br>
                  <label>จำนวนเงิน :
                    {{(item.amountSum > 0)?item.amountSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','):0}}</label><br>
                  <label>เครดิต : {{(item.balance > 0)?item.balance:0}}</label>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="card-header card-header-flex">
            <search v-bind="sentDataSearch"></search>
          </div>
          <div class="card-body">
            <tableCommission @isReload-table="isReloadTable" v-bind="sendDataTable" />
          </div>
        </div>
    </div>
</template>

<script>
import tableCommission from './tableCommission'
import search from '@/components/system/table/search/transection'
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })
export default {
  components: {
    search,
    tableCommission,
  },
  data() {
    return {
      pageType: 'withdraw',
      reloadTable: false,
      getBankSum: null,
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
    sendDataTable: function() {
      return {
        isReload: this.reloadTable,
      }
    },
  },
  methods: {
    isReloadTable() {
      this.reloadTable = !this.reloadTable
    },
    PreviewImg(img) {
      if (img !== '') {
        return img
      } else {
        return 'No Image'
      }
    },
    async getDataBankSum() {
      await apiClient.post('/withdraw/getDataBankSum/3').then(res => {
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getBankSum = setData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
  },
  async created() {
    await this.getDataBankSum()
  },
}
</script>

<style>

</style>
